var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 0H0.666667C0.489856 0 0.320286 0.0724328 0.195262 0.201364C0.0702379 0.330295 0 0.505164 0 0.6875V10.3125C0 10.4948 0.0702379 10.6697 0.195262 10.7986C0.320286 10.9276 0.489856 11 0.666667 11H7.33333C7.51014 11 7.67971 10.9276 7.80474 10.7986C7.92976 10.6697 8 10.4948 8 10.3125V0.6875C8 0.505164 7.92976 0.330295 7.80474 0.201364C7.67971 0.0724328 7.51014 0 7.33333 0ZM2.33333 8.25H1.66667V7.5625H2.33333V8.25ZM2.33333 6.875H1.66667V6.1875H2.33333V6.875ZM2.33333 5.5H1.66667V4.8125H2.33333V5.5ZM2.33333 4.125H1.66667V3.4375H2.33333V4.125ZM2.33333 2.75H1.66667V2.0625H2.33333V2.75ZM6.33333 8.25H3V7.5625H6.33333V8.25ZM6.33333 6.875H3V6.1875H6.33333V6.875ZM6.33333 5.5H3V4.8125H6.33333V5.5ZM6.33333 4.125H3V3.4375H6.33333V4.125ZM6.33333 2.75H3V2.0625H6.33333V2.75Z",
    fill: "#545454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon_list.30b475e15bc209818eee417cfed10ba9.svg";
export { ForwardRef as ReactComponent };